import type {Manifest} from './types';

const path = new URL('./branding/manifest.json', document.baseURI);
const BRANDING_MANIFEST_PATH = path.toString();
export const getBrandingPath = (path: string) =>
    new URL(path, BRANDING_MANIFEST_PATH).toString();

export const DEFAULT: Manifest = {
    version: 0,

    meta: {name: 'DEFAULT', brandVersion: 'n/a'},
    brandName: '',
    images: {},
    translations: {},
    applicationConfig: {},
    defaultUserConfig: {},
    customStepConfig: {},
};

export async function loadBranding() {
    // TODO: Use cache: 'only-if-cache' to try to get something asap, then load it again later?
    const res = await fetch(BRANDING_MANIFEST_PATH, {
        // These are necessary to re-use the preloaded manifest.
        credentials: 'include',
        mode: 'no-cors',
    });
    return res.json() as Promise<Manifest>;
}
